import React from 'react'
import { Modal } from '@components/ui'

type ChartingChangePhaseStatusModalProps = {
  show: boolean
  phaseName: string
  newStatus: string
  onCancel: () => void
  onConfirm: () => void
}

const ChartingChangePhaseStatusModal: React.FC<
  ChartingChangePhaseStatusModalProps
> = ({ show, phaseName, newStatus, onCancel, onConfirm }) => {
  const name = phaseName.trim() || 'this phase'
  const status = newStatus.trim() || 'Proposed'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title="Change phase status?"
      description={`Are you sure you want to change the status of ${name} to ${status}?`}
      primaryLabel="Confirm update"
      secondaryLabel="Cancel"
      onPrimaryClick={onConfirm}
      onSecondaryClick={onCancel}
    />
  )
}

export default ChartingChangePhaseStatusModal
